export default {"src":"/_next/static/media/decorative-curves.519adbc1.svg","height":95,"width":91,"blurWidth":0,"blurHeight":0};